import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "../assets/css/style.css"
import AspirantsParEgliseChart from "../components/region/AspirantsParEgliseChart";
import EglisesAspirants from "../components/district/EglisesAspirants";

const DashboardRegion=()=> {
  const navigate = useNavigate();
  const [aspirants, setAspirants] = useState([]);
  const [memoires, setMemoires] = useState([]);
  const [showCard, setShowCard] = useState(false);
  const [eglises, setEglises] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [parcoursCount, setParcoursCount] = useState({ total_CG: 0, total_SYL: 0 });
  const [me, setMe] = useState(null);
  const [districtName, setDistrictName] = useState("");


  const toggleCard = () => {
    setShowCard(!showCard);
  };
  useEffect(() => {
    const fetchDistrictName = async () => {
      try {
        const me = await api.get("/auth/me/district");
        const { district_id } = me.data;
        if (district_id) {
          const res = await api.get(`/districtStats/district/${district_id}/name`);
          setDistrictName(res.data.name);
        }
      } catch (err) {
        console.error("Erreur chargement district:", err);
      }
    };
    fetchDistrictName();
  }, []);
  useEffect(() => {
    api.get("/me")
    .then((res) => {
      // suivant ton backend: parfois { id, email, role, ... } ou { user: {...} }
      const payload = res.data?.user || res.data;
      setMe(payload || null);
    })
    .catch((err) => console.error("Erreur chargement /me:", err));
    api.get("/region/aspirants")
      .then((res) => setAspirants(res.data))
      .catch((err) => console.error("Erreur chargement aspirants:", err));

    api.get("/region/memoires/en_attente")
      .then((res) => setMemoires(res.data))
      .catch((err) => console.error("Erreur chargement memoires:", err));

    api.get("/auth/me/district")
      .then((res) => {
        const districtId = res.data.district_id;
        return api.get(`/locations/eglises/by-district/${districtId}`);
      })
      .then((res) => {
        setEglises(res.data);
      })
      .catch((err) => {
        console.error("Erreur chargement églises ou district :", err);
      });
    api.get("/aspirants/district/count")
      .then(res => setTotalCount(res.data.total))
      .catch(err => console.error("Erreur total aspirants:", err));

    api.get("/aspirants/district/count-parcours")
      .then(res => setParcoursCount(res.data))
      .catch(err => console.error("Erreur count parcours:", err));
  }, []);

  const total_SYL1 = Math.max(
    0,
    (Number(totalCount) || 0) - (Number(parcoursCount?.total_CG) || 0)
  );
  return (
    <div className="d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
      <main className="flex-grow-1 overflow-auto p-4 bg-surface-secondary py-2">
      <header className="pt-6 mb-4">
            <div className="container-fluid">
                <div className="mb-npx">
                    <div className="row align-items-center">
                        <div className="col-sm-12 col-12 mb-4 mb-sm-0">
                            <h1 className="h2 mb-0 ls-tight text-center">Bienvenue sur votre dashboard de Coordinateur du District <small className="text-red mt-1"> {districtName}</small></h1>
                        </div>
                    </div>
                </div>
            </div>
      </header>
        <div className="container-fluid">
        <div className="row g-3 px-3 pt-3">
        <div className="col-md-12">
          <div className="row g-3">
            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "rgb(199 212 223)" }}>
                <div className="card-body">
                    <h6 className="card-title">
                      <i className="bi bi-people-fill me-2"></i>Total Elèves
                    </h6>
                    <h3 className="mb-0">{totalCount}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "#0d6efd" }}>
                <div className="card-body">
                    <h6 className="card-title">
                      <i className="bi bi-person-check-fill me-2"></i>Elèves Chef Guide
                    </h6>
                    <h3 className="mb-0">{parcoursCount.total_CG}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "#6e0b14" }}>
                <div className="card-body">
                  <h6 className="card-title">
                    <i className="bi bi-person-check-fill me-2"></i>Elèves SYL
                  </h6>
                  <h3 className="mb-0">
                    {total_SYL1}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        <div className="d-none d-md-block">
          <AspirantsParEgliseChart/>
        </div>
        <EglisesAspirants/>
        </div>
          </div>
        </div>
      </main>
    </div>
  );
}
export default DashboardRegion;